import { gql } from "apollo-boost";

const children = gql`
  query ($filter: ChildrenFilter!) {
    children(filter: $filter) {
      total
      items {
        id
        childId
        name
        firstName
        lastName
        schoolId
        grade
        email
      }
    }
  }
`;

const child = gql`
  query child($id: String!) {
    child(id: $id) {
      id
      childId
      name
      firstName
      lastName
      email
      schoolId
      grade
      parents {
        id
        name
        email
      }
      school {
        id
        name
        grades
      }
    }
  }
`;

const findChildByFirstName = gql`
  query findChildByFirstName($firstName: String!) {
    findChildByFirstName(firstName: $firstName) {
      childId
      firstName
      lastName
      grade
      schoolId
      email
      parents {
        id
        name
        email
      }
      school {
        id
        name
      }
    }
  }
`;

const childUpdates = gql`
  query childUpdates($filter: ChildUpdateFilter) {
    childUpdates(filter: $filter) {
      items {
        id
        childId
        name
        firstName
        lastName
        schoolId
        school {
          name
        }
        grade
        createDate
        pending {
          createDate
          userId
          userName
          firstName
          lastName
          grade
          orgId
          org {
            name
          }
        }
      }
      total
    }
  }
`;

export const confirmUpdate = gql`
  mutation confirmChildUpdate($input: ConfirmChildUpdateInput!) {
    confirmChildUpdate(input: $input)
  }
`;

export const childGql = { children, child, findChildByFirstName, childUpdates, confirmUpdate };
